module.exports={
	"Form": "DocumentCreateManifest",
	"Descriptors": {
	},
	"Sections": [
		{
			"Name": "Document Create",
			"Hash": "DocumentCreate",
			"Solvers": [],
			"ShowTitle": false,
			"Groups": [
				{
					"Name": "Document Create",
					"Hash": "DocumentCreate",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}